import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import { trans } from "utils/helpers"
import { getReport, postReport } from "./api"
import { ModalForm } from "components/ModalForm/ModalForm"
import { Textbox } from "components/Textbox/Textbox"
import { Button } from "components/Button/Button"
import { ICON_TYPE, REPORT_URL } from "utils/constants"
import { Toast } from "components/ToastShow/ToastAlert"
import { removeReport } from "components/ButtonPrintIcon/api"
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect"
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect"
import { ENDPOINTS } from "utils/endpoints"
import { MessageType } from "types/enum"
interface ButtonToolbarprint {
    onClick?: () => void,
    Callback: (id: any) => void,
    objectTag?: string,
    reportDomain?: string,

}
export const ButtonPrintToolbar: React.FC<ButtonToolbarprint> = ({ onClick, Callback,objectTag ,reportDomain="OfficeAutomation" }) => {
    let profile = { isBeginner: true }; //let profile = localStorage.getItem("profile"); // type --> Profile
    const buttonToolbarReportStarting = useRef(null);
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [options, setOptions] = useState<any>()
    const [selectoptions, setSelectOptions] = useState<any>()
    const [showCreateReport, setShowCreateReport] = useState<any>(false)
    
    const [reportName, setReportName] = useState<any>()
    const [reportPath, setReportPath] = useState<any>()
    const [scope, setScope] = useState<any>()
    const [reportGroupId, setReportGroupId] = useState<any>()
    const [showOperations, setShowOperations] = useState(false);
    const formButton = useRef<any>();
    const showOperationsRef = useRef<any>(false);
    const [loading, setLoading] = useState<any>()
    const [rotate , setRotate] = useState<boolean>(false);
    function showSubMenuFunction() {
        setShowSubMenu(true)
    }
    async function sendDataAsync(data) {
        
        try {
           const res =  await postReport(data)
           Callback && Callback(res.Data+"Design")
            setShowCreateReport(false)
            getDataAsync()
        } catch (error) {
            
        }


    }
   async function getDataAsync() {
    setRotate(true)
    setLoading(false)
    try {
        let option:any = []
     if(objectTag){
         const res = await getReport(objectTag)
         Object.keys(res).map(item=>{
 
             option.push({Id:item,Name :res[item] })
         })
 
     }
     if(option.length >0){
 
         option.push({Id:"Default"+option[0].Id ,Name :trans("edit")+" "+  trans("defaulttemplate") })
     }
         option.push({Id:"Design" ,Name :"create" })
         setLoading(true)
         setOptions(option)
    } catch (error) {
        let option:any = []
        option.push({Id:"Design" ,Name :"create" })
        setOptions(option)
        setLoading(true)
    }
    }

    function selectboxValSetter(id) {
        setSelectOptions(id)
        if(id != "Design"){
            Callback && Callback(id);
        }else{
            setShowCreateReport(true)
        }
        setShowSubMenu(false)
        if(buttonToolbarReportStarting.current) (buttonToolbarReportStarting.current as HTMLButtonElement).blur();
    
    }

    function formSubmit(e){
        e.preventDefault()
        let report=  {
              "reportName": reportName,
              "ReportFileName":reportPath+".mrt",
              "isUseInDashboard": false,
              "reportGroupId": reportGroupId,
              "objectTag": objectTag,
              "scope": +scope,
            }
    /*     let applications = applicationIds?.map(item=>{return item.Id}) */
        sendDataAsync(report);
 }
 function clickToCloseSubMenu(e){
    if(e.target.type != "button")
       setShowSubMenu(false)
    document.removeEventListener("click" ,clickToCloseSubMenu)
}
function hideSubMenuFunction(e) {
   document.addEventListener("click",clickToCloseSubMenu)
       
}

 async function removeReportAsync(id) {
    try {
        await removeReport(id)
        getDataAsync()
    } catch (error) {
        
    }
}
    useEffect(() => {
        
        getDataAsync()
    }, [objectTag]);

    return (

        <>  
        {showCreateReport &&
            <ModalForm mode={"create"} title={"LetterForm"} onHide={() => { setShowCreateReport(false) }} show={showCreateReport}>
                <form className="Reserve-form py-2" >
                    <div className="card">
                <div className="card-body">
                    <div className="container">
                        <div className="row ">
                            <div className="col">
                                <Textbox  
                                    textboxType="text"
                                    textboxName="reportName"
                                    onChange={(e)=>{setReportName(e.target.value)}}
                                    defaultValue={""}
                                    labelText="PrintTemplateName"
                                    mode={"edit"}
                                />
                            </div>  
                            <div className="col">
                                <Textbox  
                                   textboxType="text"
                                   textboxName="reportPath"
                                   onChange={(e)=>{setReportPath(e.target.value)}}
                                   defaultValue={""}
                                   labelText="reportPath"
                                   mode={"edit"}
                               />
                             </div>
                            <div className="col">
                                {/* DV */}
                                <EnumerationTypeSelect
                                onChange={setScope} 
                                required={true} 
                                mode={"edit"} 
                                name="Scope"
                                label="Scope"
                                enumTypeSelect="Scope" 
                                value={null} />
                             </div>
                            <div className="col">
                                <DictionarySelectBox
                                Change={(e)=>{setReportGroupId(e) }}  
                                required={true} 
                                mode={"view"} 
                                name="ReportGroupDictionary" 
                                value={reportDomain}
                                label="ReportGroup"
                                baseUrl={REPORT_URL}
                                endPoint={ENDPOINTS.reportST.reportGroup.dictionary}
                                params={{reportDomain:reportDomain}} />
                            </div>

                        </div>
                        <div className="d-flex justify-content-end mt-4">
                            <>
                                <Button  onClick={(e)=>{formSubmit(e)}}  value="Save" btnType="submit" />
                                <Button
                                    btnType="cancel"
                                    value="Cancel"
                                    onClick={() => { setShowCreateReport(false) }}
                                />
                            </>
                        </div>
                    </div>
                 </div>
                    </div>
                </form>
                                    
            </ModalForm>
        }
        {objectTag && 
        <div className="toolbar-btn-wrapper">
            <button ref={buttonToolbarReportStarting} onClick={() => { }} onFocus={showSubMenuFunction} onBlur={hideSubMenuFunction} className="btn btn-outline-primary toolbar-btn d-flex flex-column mx-1 justify-content-center align-items-center" >
                {/* <div className={`toolbar-btn__hotkey ${profile == undefined ? "" : (profile.isBeginner ? "" : "professional-customer")}`}>F6</div> */}
                <FontAwesomeIcon icon={['fas', 'print']} width="20px" height="20px" />
                <small>{trans("print")}</small>
                <div className={`toolbar-btn-sub-menu mt-1 ${showSubMenu ? "" : "d-none"}`}>
                {loading ?
                <>
                
                    {options && options.map((option, index) => (
                    <div key={index} style={{display:"flex",cursor:"pointer" }} className="toolbar-btn-sub-menu__option" data-value={`${option.Id}`} >
                    <div className="operations__trigger-btn noHover"  ref={formButton} onFocus={()=>{setShowOperations(option.Id);showOperationsRef.current = option.Id}} onClick={(e)=>{e.stopPropagation();}} style={{position:"relative",width: "20px" , paddingLeft:0  , marginRight: "-13px"  ,marginBottom: "4px"}} tabIndex={-1}    onBlur={() => { setShowOperations(false);showOperationsRef.current = false }}>
                       {option.Name!="create" &&  
                       <FontAwesomeIcon color="grey"   icon={[ICON_TYPE, "ellipsis-v"]}/> 
                       } 
                        {(showOperations ==option.Id ||showOperationsRef.current==option.Id)&& 
                        <div onClick={e=>{e.stopPropagation()  ; selectboxValSetter(option.Id+"Design")}} style={{minWidth: "90px" ,right:"8px", top: `${9}px` ,width:"120px" }} className={`operations__operations-icons pt-1 ${(showOperations==option.Id ||showOperationsRef.current==option.Id) ? "" : "d-none"}`}>
                          <div className={`operations__operations-icon-wrapper Hover`} >
                             <div className="operations__operations-icon-wrapper " onClick={() => {  }}>
                             <FontAwesomeIcon  className="chat__chatbox-reply-btn"   color={"grey"}  icon={['fas', 'edit']} />
                                 <p>{trans("edit")}</p>
                             </div>
                           </div>
                          <div onClick={e=>{e.stopPropagation()  ;Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete , ()=>{ removeReportAsync(option.Id)})}} className={`operations__operations-icon-wrapper `} >
                             <div className="operations__operations-icon-wrapper" onClick={() =>{}}>
                             <FontAwesomeIcon icon={['fas', 'trash']} className="chat__chatbox-reply-btn"   color={`${'grey'}`} />
                                 <p>{trans("Delete")}</p>
                             </div>
                           </div>
                        
                        </div>
                        }
                    </div> 
                    <span onClick={()=>{selectboxValSetter(option.Id)}}> 
                    {trans(option.Name)}
                    </span> 
                </div> 
                   ))}
                </>
                :
                <div  className="sync-box-icon mt-4" onClick={()=>{setRotate(true);  setTimeout(()=>{ setRotate(false) }, 1500)}}   >       
                <FontAwesomeIcon icon={[ICON_TYPE , "sync"] } className={`text-primary  ${rotate ? "Rotate" : "" } `}  />  
                </div>  
                    }
                </div>
            </button>
        </div>
        }
        </>
    )
    }